import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

interface IRenderFunctionOptions {
  setOpen: (isOpen: boolean) => void;
}

const ConfirmDialog: React.FC<{
  children: (options: IRenderFunctionOptions) => React.ReactElement;
  title: string;
  description: string;
  onClose: (isConfirmed: boolean) => void;
}> = ({ children, title, description, onClose }) => {
  const [open, setOpen] = useState(false);

  function handleCancel() {
    setOpen(false);
    onClose(false);
  }

  function handleOk() {
    setOpen(false);
    onClose(true);
  }

  return (
    <>
      {children({ setOpen })}
      <Dialog open={open}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{description}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCancel}>
            <FormattedMessage id={'common.cancel'} defaultMessage={'Cancel'} />
          </Button>
          <Button onClick={handleOk}>
            <FormattedMessage id={'common.ok'} defaultMessage={'Ok'} />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmDialog;
